import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './services/auth.service';
import PrivateRoute from './routes/private.route';
import AdminRoute from './routes/admin.route';

import Login from './pages/login.page';
import Dashboard from './pages/dashbord.page';
import SubmissionDetailPage from './pages/submission-detail.page';
import SubdomainsListPage from './pages/subdomains-list';
import SubdomainEditorPage from './pages/subdomain-edit';
import PrivateLayout from './components/privateLayout';
import ServicesListPage from './pages/services-list';
import ServiceEditorPage from './pages/service-edit';
import DocumentEditorPage from './pages/document-edit';
import DocumentsListPage from './pages/document-list';
import BankListPage from './pages/banks-list';
import BankEditorPage from './pages/bank-edit';
import TransactionsPage from './pages/transaction-list';
import UserDetailsPage from './pages/user-detail';
import UsersListPage from './pages/users-list';
import PaymentLinkPage from './pages/payment-link';
import SocietiesListPage from './pages/societies-list';
import SocietyEditorPage from './pages/society-edit';
import FieldCatalogPage from './pages/fields-list';
import AccountingExportPage from './pages/accounting-export.page';
import EmailTemplatesListPage from './pages/email-templates-list';
import EmailTemplateEditor from './pages/email-templete-edit';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <PrivateLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />

            {/* namespaced detail route */}
            <Route path=":id" element={<SubmissionDetailPage />} />

            {/* RELATIVE paths (no leading slash) */}
            <Route path="transactions" element={<TransactionsPage />} />
            <Route path="payment-link" element={<PaymentLinkPage />} />
            <Route path="users" element={<UsersListPage />} />
            <Route path="user/:email" element={<UserDetailsPage />} />
            <Route path="accounting-export" element={<AccountingExportPage />} />

            <Route path="subdomains" element={<AdminRoute><SubdomainsListPage /></AdminRoute>} />
            <Route path="subdomain/:subdomain" element={<AdminRoute><SubdomainEditorPage /></AdminRoute>} />
            <Route path="services" element={<AdminRoute><ServicesListPage /></AdminRoute>} />
            <Route path="service/:id" element={<AdminRoute><ServiceEditorPage /></AdminRoute>} />
            <Route path="documents" element={<AdminRoute><DocumentsListPage /></AdminRoute>} />
            <Route path="document/:id" element={<AdminRoute><DocumentEditorPage /></AdminRoute>} />
            <Route path="banks" element={<AdminRoute><BankListPage /></AdminRoute>} />
            <Route path="bank/:id" element={<AdminRoute><BankEditorPage /></AdminRoute>} />
            <Route path="societies" element={<AdminRoute><SocietiesListPage /></AdminRoute>} />
            <Route path="society/:id" element={<AdminRoute><SocietyEditorPage /></AdminRoute>} />
            <Route path="fields" element={<AdminRoute><FieldCatalogPage /></AdminRoute>} />
            <Route path="field/:id" element={<AdminRoute><FieldCatalogPage /></AdminRoute>} />
            <Route path="/email-templates" element={<AdminRoute><EmailTemplatesListPage /></AdminRoute>} />
            <Route path="/email-templates/:id" element={<AdminRoute><EmailTemplateEditor /></AdminRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;